import { render, staticRenderFns } from "./list-to-exchange-btn.vue?vue&type=template&id=508a053f&"
import script from "./list-to-exchange-btn.vue?vue&type=script&lang=js&"
export * from "./list-to-exchange-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports